import SinglePage from './SinglePage';

export default SinglePage;
